<div class="chatbot-wrapper">
  <!-- Chat Panel -->
  <div class="chatbot-panel" *ngIf="isOpen" [dir]="dir">
    <!-- Header -->
    <div class="chatbot-header">
      <div class="d-flex align-items-center gap-10">
        <!-- <div class="chatbot-avatar">
          <mat-icon>smart_toy</mat-icon>
        </div> -->
        <div>
          <p class="chatbot-title m-0" translate>CHATBOT.TITLE</p>
          <p class="chatbot-subtitle m-0" translate>CHATBOT.SUBTITLE</p>
        </div>
      </div>
      <div class="d-flex align-items-center gap-10">
        <button
          mat-icon-button
          class="chatbot-header-btn"
          (click)="toggleChat()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Loading conversation -->
    <div *ngIf="state === 'loading'" class="chatbot-status">
      <mat-spinner diameter="28"></mat-spinner>
      <p class="m-0" translate>CHATBOT.LOADING</p>
    </div>

    <!-- Unavailable -->
    <div *ngIf="state === 'unavailable'" class="chatbot-status">
      <mat-icon class="chatbot-status-icon">info_outline</mat-icon>
      <p class="m-0" translate>CHATBOT.UNAVAILABLE</p>
      <button class="chatbot-new-conv-btn w-auto" (click)="loadConversation()">
        <mat-icon class="chatbot-new-conv-icon">refresh</mat-icon>
        <span translate>CHATBOT.RETRY</span>
      </button>
    </div>

    <!-- Chat view -->
    <ng-container *ngIf="state === 'ready'">
      <!-- Messages -->
      <div class="chatbot-messages" #messageContainer>
        <div
          *ngFor="let msg of messages"
          class="message-row"
          [class.user-row]="msg.role === 'user'"
        >
          <div
            *ngIf="msg.role === 'assistant'"
            class="ai-bubble"
            [class.error-bubble]="msg.isError"
          >
            {{ msg.content }}
            <button
              *ngIf="msg.canRetry"
              class="chatbot-retry-btn"
              (click)="retryLastMessage()"
              [disabled]="!canSend"
            >
              <mat-icon>refresh</mat-icon>
              <span translate>CHATBOT.RETRY</span>
            </button>
            <span class="message-timestamp">{{
              msg.createdAt | date: 'd MMM, y - h:mm a'
            }}</span>
          </div>
          <div *ngIf="msg.role === 'user'" class="user-bubble">
            {{ msg.content }}
            <span class="message-timestamp">{{
              msg.createdAt | date: 'd MMM, y - h:mm a'
            }}</span>
          </div>
        </div>

        <!-- Typing indicator -->
        <div *ngIf="isTyping" class="message-row">
          <div class="ai-bubble typing-bubble">
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-text" translate>CHATBOT.TYPING</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="chatbot-footer">
        <button
          class="chatbot-new-conv-btn"
          (click)="startNewConversation()"
          [disabled]="isResetting || isTyping"
        >
          <mat-icon class="chatbot-new-conv-icon">add_circle_outline</mat-icon>
          <span translate>CHATBOT.NEW_CONVERSATION</span>
        </button>
        <div class="chatbot-input-row">
          <input
            class="chatbot-input"
            [(ngModel)]="messageText"
            [placeholder]="'CHATBOT.PLACEHOLDER' | translate"
            (keyup.enter)="sendMessage()"
            [disabled]="!canSend"
            maxlength="4000"
            autocomplete="off"
          />
          <button
            class="chatbot-send-btn"
            (click)="sendMessage()"
            [disabled]="!messageText.trim() || !canSend"
          >
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Floating Action Button -->
  <button class="chatbot-fab" (click)="toggleChat()" *ngIf="!isOpen">
    <mat-icon>chat_bubble_outline</mat-icon>
  </button>
</div>
